import { LearnMoreLink, Text, Toggle } from '@ui/themed';
import type { ReactNode } from 'react';

export function SettingToggleRow({
  label,
  description,
  checked,
  onChange,
  mono,
  truncate,
  learnMoreUrl,
  disabled,
  helpText,
  replacement,
}: {
  label: ReactNode;
  description?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  mono?: boolean;
  truncate?: boolean;
  learnMoreUrl?: string;
  disabled?: boolean;
  helpText?: ReactNode;
  /** Rendered instead of the toggle, e.g. a {@link PlanUpgradePrompt}. */
  replacement?: ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex min-w-0 flex-1 flex-col">
        <Text>{label}</Text>
        {(description || learnMoreUrl) && (
          <Text size="sm" variant="secondary" mono={mono} truncate={truncate}>
            {description}
            {learnMoreUrl && (
              <>
                {' '}
                <LearnMoreLink link={learnMoreUrl} />
              </>
            )}
          </Text>
        )}
      </div>
      <div className="flex flex-col items-end">
        {replacement ?? <Toggle checked={checked} onChange={onChange} disabled={disabled} />}
        {helpText && <div className="mt-2 flex items-center text-gray-500 text-xs">{helpText}</div>}
      </div>
    </div>
  );
}
